import { useMemo } from 'react';
import PropTypes from 'prop-types';

import styles from './section.module.scss';

export const Section = ({
  className,
  color = 'inherit',
  size = 'md',
  noPaddingTop = false,
  noPaddingBottom = false,
  contentVisibility = false,
  backgroundImageUrl,
  ...props
}) => {
  const wrapperClassName = useMemo(
    () =>
      [
        styles.wrapper,
        styles[color],
        styles[size],
        noPaddingTop ? styles.noPaddingTop : '',
        noPaddingBottom ? styles.noPaddingBottom : '',
        contentVisibility ? styles.contentVisibility : '',
      ].join(' '),
    [color, size, noPaddingTop, noPaddingBottom, contentVisibility]
  );

  return <section className={wrapperClassName} {...props} />;
};

Section.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'grey',
    'white',
    'black',
    'inherit',
    'transparent',
  ]),
  noPaddingTop: PropTypes.bool,
  noPaddingBottom: PropTypes.bool,
  contentVisibility: PropTypes.bool,
};
